import React from "react";
import * as ContextMenuPrimitive from "@radix-ui/react-context-menu";
import { ContextMenuItem } from "./ContextMenuItem";
import { ContextMenuItems } from "./types";
import { contextMenuContentVariants } from "./variants";

interface ContextMenuContentProps<TData> {
  contextMenuItems?: ContextMenuItems<TData>[];
  data: TData;
}

export const ContextMenuContent = <TData,>({
  contextMenuItems,
  data,
}: ContextMenuContentProps<TData>) => {
  return (
    <ContextMenuPrimitive.Content className={contextMenuContentVariants()}>
      {contextMenuItems?.map((contextMenuItem) => (
        <ContextMenuItem
          key={contextMenuItem.id}
          contextMenuItem={contextMenuItem}
          data={data}
        />
      ))}
    </ContextMenuPrimitive.Content>
  );
};
